<template>
	<div class="top-ranking">
		<div class="top-ranking.view" v-for="(rank,index) in topRankData" :key="index" :class="{ ' +top-two': index == 1, '+top-three': index == 2 }" @click="goRankDetail(rank)" data-aos="zoom-in-up">
			<div class="top-ranking.view.icon">
				<img src="../assets/case/top-2.png" v-if="index == 0"/>
				<img src="../assets/case/top-1.png" v-if="index == 1"/>
				<img src="../assets/case/top-3.png"  v-if="index == 2"/>
			</div>
			<div class="top-ranking.view.logo">
				<img :src="rank.icon">
			</div>
			<div class="top-ranking.view.line"></div>
			<h4>{{rank.name}}</h4>
			<span>{{rank.desc}}</span>
			<p>{{rank.desc}}</p>
			<a href="javascript:;">查看详情</a>
		</div>
		
	</div>
</template>

<script>
	export default {
		props:['topRanks'],
		computed:{
			topRankData(){
				
				if(this.topRanks.length > 0){
					//console.log(this.topRanks)
					//console.log(this.swapArray(this.topRanks,0,1))
					this.swapArray(this.topRanks,0,1)
				}
				return this.topRanks.map(({ name, image, illustration_image, id,synopsis}) => {
						return {
							name: name,
							desc: synopsis,
							id: id ,
							icon: this.imgUrl + image
						}
					})
			}
		},
		methods:{
			goRankDetail(row){
					//this.$router.push(this.$route.path + '/' +row.id)
					let routeUrl = this.$router.resolve({
						path: this.$route.path + '/' +row.id,
					});
					window.open(
					  location.pathname + "#" + routeUrl.resolved.fullPath,
					  "_blank"
					); //线上发布用
			},
			swapArray(arr, index1, index2) {
			      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			return arr;
			}
		}
	}
</script>

<style lang="scss">
	@include component(top-ranking) {
		width: 100%;
		display: flex;
		justify-content: center;
		height: 475px;
		background: #FFFFFF;
		color: #333333;

		@include part(view) {
			width: 280px;
			height: 350px;
			background: rgba(255, 255, 255, 1);
			border: 5px solid rgba(195, 211, 226, 1);
			box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
			position: relative;
			margin-top: 85px;
			cursor: pointer;

			h4 {
				margin: 0;
				font-size: 24px;
				margin-top: 26px;
				transition: all 0.35s ease-in-out;
				transform: scale(1) translateY(0);
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				padding: 0 30px;
			}

			span {
				width: 100%;
				display: inline-block;
				font-size: 16px;
				color: #999999;
				text-align: left;
				margin-top: 17px;
				padding: 0 30px;
				line-height: 24px;
				transform: scale(1);
				transition: all 0.35s ease-in-out;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				text-align: center;
			}

			p {
				transform: scale(0) translateY(100px);
				font-size: 16px;
				color: #999999;
				padding: 0 30px;
				transition: all 0.35s ease-in-out;
				opacity: 0;
				height: 82px;
				//margin-top: 15px;
				display:-webkit-box;
				 text-overflow: ellipsis;
				-webkit-box-orient:vertical;
				-webkit-box-clamp:3; //截取第三行
				overflow:hidden;
			}

			a {
				display: inline-block;
				line-height: 46px;
				;
				width: 210px;
				height: 46px;
				background: rgba(244, 114, 39, 1);
				border-radius: 2px;
				transition: all 0.35s ease-in-out;
				transform: scale(0);
				color: #FFFFFF;
				opacity: 0;
			}

			@include part(icon) {
				width: 100%;
				margin-top: -20px;
				display: flex;
				justify-content: center;
				transition: all 0.35s ease-in-out;
				transform: scale(0.9);

				img {
					display: block;
				}
			}

			@include part(logo) {
				width: 100%;
				//margin-top: 18px;
				display: flex;
				justify-content: center;
				transition: all 0.2s ease-in-out;
				transform: scale(1);
				transition: all 0.35s ease-in-out;
                height:78px;
				img {
					display: block;
					width: 100%;
					object-fit: contain;
					object-position: center;
				}
			}

			@include part(line) {
				width: 210px;
				margin: 0 auto;
				height: 1px;
				background: #F2F2F2;
				margin-top: 27px;
				transition: all 0.35s ease-in-out 0;
				transform: scale(1);
			}

			&:hover {
				@include part(logo) {
					transform: scale(0);
				}

				@include part(icon) {
					transform: scale(1);
				}

				@include part(line) {
					transform: scale(0);
				}

				h4 {
					transform: scale(0.9) translateY(-120px);
				}

				span {
					transform: scale(0);
				}

				p {
					transform: scale(1) translateY(-140px);
					opacity: 1;
				}

				a {
					transform: scale(1) translateY(-120px);
					opacity: 1;
				}
			}

		}

		@include tweak(top-two) {
			height: 380px;
			margin: 0 40px;
			border-color: #F6DD60;
			margin-top: 55px;
		}

		@include tweak(top-three) {
			border-color: #F9A771;
		}


	}
</style>
